import * as React from 'react'
import { create } from 'zustand'

// Jak ConfirmedViolationModel w WPF: pamiętamy odznaczone, więc nowe naruszenia drukują się domyślnie.
// Klucz to firma, bo id naruszeń powtarzają się między bazami firm.
type State = {
  excludedByCompany: Record<string, number[]>
}

type Actions = {
  setPrinted: (companyId: string, ids: number[], printed: boolean) => void
}

const EMPTY: number[] = []

export const useViolationPrintStore = create<State & Actions>()((set) => ({
  excludedByCompany: {},

  setPrinted: (companyId, ids, printed) =>
    set((s) => {
      const excluded = new Set(s.excludedByCompany[companyId] ?? EMPTY)
      ids.forEach((id) => (printed ? excluded.delete(id) : excluded.add(id)))
      return {
        excludedByCompany: {
          ...s.excludedByCompany,
          [companyId]: Array.from(excluded),
        },
      }
    }),
}))

export const getExcludedViolations = (companyId: string | undefined) =>
  companyId
    ? (useViolationPrintStore.getState().excludedByCompany[companyId] ?? EMPTY)
    : EMPTY

export const useExcludedViolations = (companyId: string | undefined) => {
  const ids = useViolationPrintStore((s) =>
    companyId ? (s.excludedByCompany[companyId] ?? EMPTY) : EMPTY,
  )
  return React.useMemo(() => new Set(ids), [ids])
}
